<template>
    <div>

        <navbar></navbar>

        <div class="bg-header-round-small">
            <div class="container">
                <h1>Kontakt</h1>
            </div>
        </div>
        <section class="container">
            <h2>Nimm Kontakt zu uns auf</h2>
            <p class="mb-2">
                Dein Ansprechpartner:
            </p>
            <p>
                Andreas Sparber<br>
                Maxhofstr. 34, 81475 München<br>
                Telefonnummer: 089 7240 82 82<br>
                www.couch-gourmet.com<br>
                info@couch-gourmet.com
            </p>
        </section>

        <cgfooter></cgfooter>

    </div>
</template>

<script>
  import Navbar from '@/components/Navbar.vue'
  import CgFooter from '@/components/CgFooter.vue'

  export default {
    name: 'serviceContact',
    components: {
      'navbar': Navbar,
      'cgfooter': CgFooter
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/service/Contact.vue